<div *ngIf="isShareSupported" class="share-container">
  {{ 'ACTIONS.SHARE' | translate }}
  <ion-button shape="round" fill="outline" (click)="share()">
    <i class="icon-share2"></i>
  </ion-button>
</div>
